export const bestTeachersData = [
  {
    id: 1,
    teacherName: 'افشین زنگنه',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/51.jpg',
  },
  {
    id: 2,
    teacherName: 'مرتضی شهرابی فراهانی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/31.jpg',
  },
  {
    id: 3,
    teacherName: 'محمد مهدی جاوید',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/43.jpg',
  },
  {
    id: 4,
    teacherName: 'غزل بخشنده',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
  {
    id: 5,
    teacherName: 'بیان دیوانی آذر',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/13.jpg',
  },
  {
    id: 6,
    teacherName: 'دانیال بازمانده',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/3.jpg',
  },
  {
    id: 7,
    teacherName: 'حانیه جعفری',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/81.jpg',
  },
  {
    id: 8,
    teacherName: 'سید عماد موسوی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/44.jpg',
  },
  {
    id: 9,
    teacherName: 'باوان دیوانی آذر',
    teacherImgSrc: 'https://randomuser.me/api/portraits/women/84.jpg',
  },
  {
    id: 10,
    teacherName: 'علی صداقی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/42.jpg',
  },
  {
    id: 11,
    teacherName: 'مصطفی حسینی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/76.jpg',
  },
  {
    id: 12,
    teacherName: 'امیرمحمود رضایی',
    teacherImgSrc: 'https://randomuser.me/api/portraits/men/18.jpg',
  },
];
